import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPeepRelatedLeadCards as GetPeepRelatedLeadCardsQuery,
    GetPeepRelatedLeadCardsVariables as GetPeepRelatedLeadCardsQueryVariables,
} from 'nutshell-graphql-types';

import GET_PEEP_RELATED_LEAD_CARDS from '../../graphql/queries/get-peep-related-lead-cards.graphql';

export const useGetPeepRelatedLeadCards = (id: string) => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetPeepRelatedLeadCardsQuery, GetPeepRelatedLeadCardsQueryVariables>(
        GET_PEEP_RELATED_LEAD_CARDS,
        {
            variables: {id},
            fetchPolicy: 'cache-and-network',
        }
    );

    const peep = data ? data.peep : null;

    return {
        isLoading,
        peep: peep,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
